import { SceneWrapper } from '~/components';
import { type FormikProps, isEmpty, useFormikContext } from '~/modules';
import type { OnboardingCepFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

type Props = {
  loading: boolean;
};

const OnboardingCep = ({ loading }: Props) => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
    touched,
  }: FormikProps<OnboardingCepFormValues> = useFormikContext();

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="cep-onboarding"
          onPress={submitForm}
          disabled={!isValid || isEmpty(values.cep)}
          onLoading={loading}
          fullWidth
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <Input
        autoFocus
        placeholder="00000-000"
        name="cep"
        id="cep"
        value={values.cep}
        onChange={(e) => setFieldValue('cep', e.target.value)}
        label="CEP"
        errors={touched?.cep && errors?.cep}
        maskType="cep"
        inputMode="numeric"
        inputProps={{ inputMode: 'numeric' }}
      />
    </SceneWrapper>
  );
};

export default OnboardingCep;
